import React, { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { IoFilterOutline } from "react-icons/io5";

import Button from "../../../components/button";

import inactive_check_circle from "../../../assets/icons/inactive-check-circle.png";
import active_check_circle from "../../../assets/icons/active-check-circle.png";
import { getCompanyList } from "../../../api/company/companyReq";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import dayjs from "dayjs";
type SideMenuBarType = {
  onSelectCompany: (data: any) => void;
};
type menuType = {
  id: number;
  name: string;
  route: string;
  Status: string;
  companyCity: string;
  subscriptionValidUpto: string;
  disabled: boolean;
};

const SideMenuBar = (props: SideMenuBarType) => {
  const { onSelectCompany } = props;
  const { clients } = useSelector((_state: RootState) => _state);

  const [activeMenuId, setactiveMenuId] = useState(1);
  const [menuList, setmenuList] = useState<menuType[]>([]);
  const [filteredList, setfilteredList] = useState<menuType[]>([]);

  const onChangeCompany = (data: menuType) => {
    setactiveMenuId(data?.id);
    onSelectCompany(data);
  };

  const getMenuItems = async () => {
    try {
      let _menulist: menuType[] = [];
      for (let i = 0; i < clients?.data?.length; i++) {
        const menu = clients?.data[i];
        _menulist.push({
          id: menu.companyID || i,
          name: menu.CompanyName || "",
          Status: menu.Status || "",
          companyCity: menu.companyCity || "",
          subscriptionValidUpto: menu.subscriptionValidUpto || "",
          route: "",
          disabled: false,
        });
      }
      onSelectCompany(_menulist[0]);
      setactiveMenuId(_menulist[0].id);
      setmenuList(_menulist);
      setfilteredList(_menulist);
    } catch (error: any) {
      toast.error(error?.errMessage);
    }
  };

  const filterMenuList = (filterStatus: string) => {
    if (filterStatus) {
      const filteredList = menuList.filter(
        (item) => item?.Status?.toLowerCase() === filterStatus?.toLowerCase()
      );
      setfilteredList(filteredList);
      onSelectCompany(filteredList[0]);
      if (filteredList?.length < 1) return;
      setactiveMenuId(filteredList[0]?.id);
    } else {
      // If no filter status is selected, reset to the original list
      getMenuItems();
    }
  };

  useEffect(() => {
    if (!clients?.data) return;
    getMenuItems();
  }, [clients?.data]);

  return (
    <SideMenuBarWrapper className="px-1 py-2">
      <div className="d-flex align-items-center">
        <div className="w-50 mx-2">
          <div className="rounded bg-white border w-100 sm-text status_dropdown">
            <select
              onChange={(e) => filterMenuList(e.target.value)}
              className="rounded border-0 w-100 sm-text secondary-color "
            >
              <option value={""}>All</option>
              <option value={"Active"}>Active</option>
              <option value={"Paused"}>Paused</option>
              <option value={"Inactive"}>Inactive</option>
            </select>
          </div>
        </div>
        <div className="">
          <IoFilterOutline color="#3A93F4" size={25} className="" />
        </div>
      </div>
      <div className="menu_container py-4">
        {filteredList.map((item, idx) => (
          <MenuCard
            key={idx}
            $active={activeMenuId === item.id}
            className="m-2 sm-text p-1 ps-2 py-2"
            onClick={() => onChangeCompany(item)}
          >
            <div className="d-flex flex-grow-1 justify-content-between">
              <strong className="md-text mx-1">{item.name}</strong>
              <b
                style={{
                  color:
                    item.Status === "Inactive" || item.Status === "Paused"
                      ? "red"
                      : "#198754",
                }}
                className={`x-sm-text text-capitalize text mx-2`}
              >
                {item.Status}
              </b>
            </div>
            <div className="p-1"></div>
            <div className="d-flex flex-grow-1 justify-content-between">
              <p className="x-sm-text mx-1">{item.companyCity}</p>
              <strong className=" x-sm-text text-capitalize secondary-color mx-2">
                {!dayjs(item?.subscriptionValidUpto).isValid()
                  ? "NA"
                  : dayjs(item?.subscriptionValidUpto).format("MMM DD, YYYY")}
              </strong>
            </div>
          </MenuCard>
        ))}
        {/* {menuList.map((item, idx) => (
          <MenuBtn
            key={idx}
            $active={activeMenuId === item.id}
            className="my-1 sm-text p-1 ps-2 py-2"
            onClick={() => onChangeCompany(item)}
          >
            {item.name}
          </MenuBtn>
        ))} */}
      </div>
    </SideMenuBarWrapper>
  );
};

export default memo(SideMenuBar);

const SideMenuBarWrapper = styled.div`
  width: 300px;
  height: 100%;
  overflow-y: auto;
  /* border: 1px solid brown; */
  .menu_container {
  }
  .status_dropdown {
    height: 30px;
    display: flex;
    align-items: center;
  }
  .status_dropdown select {
    outline: none;
  }
`;

const MenuCard = styled.div<{ $active?: boolean }>`
  background-color: white;
  border-radius: 8px;
  border: 1px solid
    ${(props) => (props?.$active ? "#007bff" : "rgb(200,200,200)")};
`;

const MenuBtn = styled.button<{ $active?: boolean }>`
  background-color: none;
  background: ${(props) => (props?.$active ? "white" : "none")};
  border: none;
  border-bottom: ${(props) => (props?.$active ? "2px solid #007bff" : "none")};
  outline: none;
  display: flex;
  flex: 1;
  align-items: flex-start;
  align-items: center;
  flex-grow: 1;
  box-sizing: border-box;
  width: 100%;
  border-radius: 2px;
  .check_icon {
    /* border: 1px solid; */

    width: 17px;
    /* height: 17px; */
    margin: 0px 10px 0px 5px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    /* filter: grayscale(10); */
  }
`;
